export default __webpack_public_path__ + "static/media/InPo.89284fc2.png";